import { useEffect } from "react";

/**
 * Lightweight SEO hook — updates the document <title> and meta description
 * for the current page. No external dependencies. Safe to use anywhere.
 *
 * Usage:
 *   usePageMeta({
 *     title: "Lavender Essential Oil — Pure French | DC Gift World Too",
 *     description: "Pure French lavender essential oil for sleep, relaxation, and DIY blends. Third-party GC/MS tested. Free shipping over $75.",
 *   });
 */
export default function usePageMeta({ title, description }) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}
